(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gecko-faq"]) return;
  try {
    
document.querySelectorAll('[data-sg-tabs]').forEach(function (tabs) {
  tabs.querySelectorAll('.sg-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      tabs.querySelectorAll('.sg-tab-btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      tabs.querySelectorAll('.sg-tab-panel').forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === btn.dataset.tab); });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gecko-kontakt"]) return;
  try {
    
document.querySelectorAll('.sg-cform').forEach(function (form) {
  form.setAttribute('novalidate', 'novalidate');
  var fields = form.querySelectorAll('.sg-field input, .sg-field textarea');

  function validate(el) {
    var field = el.closest('.sg-field');
    var err = field.querySelector('.sg-field-err');
    var msg = '';
    var val = el.value.trim();
    if (!val) {
      msg = 'Bitte füll dieses Feld aus';
    } else if (el.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)) {
      msg = 'Bitte gib eine gültige E-Mail-Adresse ein';
    }
    if (msg) { field.classList.add('has-error'); err.textContent = msg; return false; }
    field.classList.remove('has-error'); err.textContent = ''; return true;
  }

  fields.forEach(function (el) {
    el.addEventListener('blur', function () { validate(el); });
    el.addEventListener('input', function () {
      if (el.closest('.sg-field').classList.contains('has-error')) validate(el);
    });
  });

  form.addEventListener('submit', function (e) {
    var ok = true, first = null;
    fields.forEach(function (el) { if (!validate(el)) { ok = false; if (!first) first = el; } });
    if (!ok) { e.preventDefault(); if (first) first.focus(); }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gecko-tracking"]) return;
  try {
    
document.querySelectorAll('[data-track-form]').forEach(function (form) {
  var wrap = form.closest('.sg-block');
  var mode = 'tracking';
  var err = wrap.querySelector('[data-track-err]');
  var result = wrap.querySelector('[data-track-result]');
  var fallback = wrap.querySelector('[data-track-fallback]');

  wrap.querySelectorAll('[data-mode-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      mode = btn.dataset.modeBtn;
      wrap.querySelectorAll('[data-mode-btn]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      form.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = (p.dataset.panel !== mode); });
      if (err) err.hidden = true;
    });
  });

  function showTracking(num) {
    var url = 'https://t.17track.net/de#nums=' + encodeURIComponent(num);
    if (fallback) { fallback.href = url; fallback.hidden = false; }
    if (typeof YQV5 === 'undefined') {
      window.open(url, '_blank');
      return;
    }
    result.hidden = false;
    YQV5.trackSingle({
      YQ_ContainerId: 'YQContainer',
      YQ_Height: 560,
      YQ_Fc: '0',
      YQ_Lang: 'de',
      YQ_Num: num
    });
    result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (mode === 'tracking') {
      var t = form.querySelector('input[name=tracking]').value.trim();
      if (!t) { if (err) err.hidden = false; return; }
      if (err) err.hidden = true;
      showTracking(t);
    } else {
      var o = form.querySelector('input[name=order]').value.trim();
      if (!o) { if (err) err.hidden = false; return; }
      window.location.href = '/account';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
